// Добавляем class highlight
var aSpecialChars = new Array( '\\', '.', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '[', ']', '{', '}', '/', '"', "'", "|" );
jQuery.fn.highlight = function (str, className) {
	for(var i in aSpecialChars)
	{
		var sVal = aSpecialChars[i];
		str = str.split(sVal).join('\\'+sVal);
	}
		    var regex = new RegExp(str, "gi");
		    return this.each(function () {
		        $(this).contents().filter(function() {
		            return this.nodeType == 3 && regex.test(this.nodeValue);
		        }).replaceWith(function() {
		            return (this.nodeValue || "").replace(regex, function(match) {
		                return "<span class=\"" + className + "\">" + match + "</span>";
		            });
		        });
		    });
		};

// Очищаем все highlight
jQuery.fn.removeHighlight = function() {
	 function newNormalize(node) {
	    for (var i = 0, children = node.childNodes, nodeCount = children.length; i < nodeCount; i++) {
	        var child = children[i];
	        if (child.nodeType == 1) {
	            newNormalize(child);
	            continue;
	        }
	        if (child.nodeType != 3) { continue; }
	        var next = child.nextSibling;
	        if (next == null || next.nodeType != 3) { continue; }
	        var combined_text = child.nodeValue + next.nodeValue;
	        var new_node = node.ownerDocument.createTextNode(combined_text);
	        node.insertBefore(new_node, child);
	        node.removeChild(child);
	        node.removeChild(next);
	        i--;
	        nodeCount--;
	    }
	 }
	 return this.find("span.highlight").each(function() {
	    var thisParent = this.parentNode;
	    thisParent.replaceChild(this.firstChild, this);
	    newNormalize(thisParent);
	 }).end();
	};
